import { useEffect, useRef } from 'react';

function useInterval(callback, delay, stop) {
  var savedCallback = useRef();
  useEffect(function () {
    savedCallback.current = callback;
  });
  useEffect(function () {
    function tick() {
      savedCallback.current();
    }

    var id = setInterval(tick, delay);
    if (stop) clearInterval(id);
    return function () {
      return clearInterval(id);
    };
  }, [stop]);
}

export default useInterval;